import { parseRequestError } from '@/common/utilities.ts'
import axiosInstance from '@/libs/axios_config.ts'
import { AppRoutePaths } from '@/routing/route_paths'
import {
  InitiateIDResponseSchema
} from './identity-verification.schema'

const baseUrl = '/family_application/identity_verification'

export const GETVerifyIdentity = async (
  sessionId: string,
  programId: number
) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/${sessionId}`, { 
      params: { 
        program_id: programId
      }
    })
    return response.data
  } catch (error) {
    throw new Error(parseRequestError(error).message)
  }
}

export const GETInitiateIdentityVerification = async () => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/initiate`, {
      params: {
        redirect_url: `${window.location.origin}${AppRoutePaths.family_application.identity_verification.submitted}`,
      },
    })

    return InitiateIDResponseSchema.parse(response.data)
  } catch (error) {
    throw new Error(parseRequestError(error).message)
  }
}
